"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TooltipOverlay {
    handleCloseButton(originalEvent) {
        this.emit("overlay-close", { originalEvent });
    }
}
module.exports = TooltipOverlay;
